import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "row mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-semibold fs-6" }, "Profile Photo", -1)
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-lg-6 fv-row fv-plugins-icon-container",
  style: {"position":"relative","display":"inline-block"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash fs-7 text-white" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "avatar-uploader-icon d-flex align-items-center justify-content-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera fa-1x" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg. Recommended size 150 x 300.", -1)
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-semibold fs-6" }, "Production Name", -1)
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-semibold fs-6" }, "Profile Category", -1)
const _hoisted_22 = { class: "col-lg-8" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-semibold fs-6" }, "StageCode", -1)
const _hoisted_27 = { class: "col-lg-8" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_30 = { class: "d-flex justify-content-end" }
const _hoisted_31 = {
  key: 0,
  class: "col-12 col-md-12 col-xl-5"
}
const _hoisted_32 = { class: "mb-5" }
const _hoisted_33 = { class: "d-flex mb-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Widgets"),
  /*#__PURE__*/_createElementVNode("div", { class: "small" }, "add important information to your production's dashboard ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline" }, "Widget", -1)
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = { class: "fs-4 fw-bolder" }
const _hoisted_41 = {
  key: 0,
  class: "fw-bold fs-6 text-gray-500"
}
const _hoisted_42 = {
  key: 1,
  class: "fw-bold fs-6 text-gray-500"
}
const _hoisted_43 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.hasAvatar && !_ctx.photoIsLoading && false)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                  style: {"left":"65%","top":"75%","position":"absolute","z-index":"1"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removePhoto && _ctx.removePhoto(...args))),
                  title: "Remove avatar"
                }, _hoisted_8))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
              class: "avatar-uploader",
              "show-file-list": false,
              "on-success": _ctx.handleAvatarSuccess,
              "before-upload": _ctx.beforeAvatarUpload,
              "http-request": _ctx.requestCropper
            }, {
              default: _withCtx(() => [
                (_ctx.hasAvatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.production.photo,
                      class: "avatar-entity",
                      width: "150",
                      height: "300",
                      alt: ""
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              ]),
              _: 1
            }, 8, ["on-success", "before-upload", "http-request"])), [
              [_directive_loading, _ctx.photoIsLoading]
            ]),
            _hoisted_13
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control form-control-lg mb-3 mb-lg-0", {'is-invalid': _ctx.v$.production.name.$error}]),
              placeholder: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.production.name) = $event))
            }, null, 2), [
              [_vModelText, _ctx.production.name]
            ]),
            _hoisted_19
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Selector2, {
              options: _ctx.productionTypeOptions,
              modelValue: _ctx.production.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.production.type) = $event))
            }, null, 8, ["options", "modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-lg mb-3 mb-lg-0",
              placeholder: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.production.stageCode) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.production.stageCode]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_Button, { onClick: _ctx.update }, {
        default: _withCtx(() => [
          _createTextVNode("Save Changes")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_component_Button, {
                type: "secondary",
                class: "btn-sm ms-auto",
                onClick: _ctx.invokeAddWidget
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Add "),
                  _hoisted_35
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.production.widgets, (widget) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex align-items-center",
                  key: widget.name
                }, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.invokeUpdateWidget(widget)),
                    class: "cursor-pointer border border-gray-300 border-dashed rounded min-w-150px py-3 px-4 me-6 mb-3"
                  }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(widget.name), 1)
                    ]),
                    (widget.type === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(widget.value), 1))
                      : _createCommentVNode("", true),
                    (widget.type === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("a", {
                            class: "link-primary",
                            href: widget.link,
                            target: "_blank"
                          }, _toDisplayString(widget.value), 9, _hoisted_43)
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_38)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.isFetching]
  ])
}